import {ref} from 'vue';
import {defineStore} from 'pinia';
import {useErrorHandler} from '@malt/utils';
import type {FreelancerInformationResource, FreelancerInformationResourceComplianceInvalidStatesEnum, FreelancerOverviewResource} from '@api';
import {freelancerInformationEndpoints} from '@/registry';

export const useFreelancerInformationStore = defineStore('freelancer-information', () => {
    const {handleUnknownError} = useErrorHandler();
    // data
    const freelancerInformation = ref<FreelancerInformationResource | null>(null);
    const invalidStates = ref<FreelancerInformationResourceComplianceInvalidStatesEnum[]>([]);
    const freelancerResource = ref<FreelancerOverviewResource | null>(null);

    async function fetchFreelancerInformation() {
        try {
            freelancerInformation.value = await freelancerInformationEndpoints.information();

            freelancerResource.value = freelancerInformation.value?.freelancer ?? null;

            // Reset invalidStates
            invalidStates.value = [];

            // Set invalidStates
            if (freelancerInformation.value?.complianceInvalidStates?.length) {
                invalidStates.value = freelancerInformation.value.complianceInvalidStates;
            }
        } catch (e) {
            handleUnknownError(e, {showSnackbar: false});
        }
    }

    return {fetchFreelancerInformation, freelancerInformation, invalidStates, freelancerResource};
});
